import { useAuth0 } from "@auth0/auth0-react";
import { useAppSelector } from "../../Redux/hooks";
// import Candidates from "../Lookup/Candidates";
import { useEffect, useState } from "react";
import { auth0Config } from "../../Config/auth0Conifg";
import Candidates from "../Lookup/Candidates";

export default function CandidatePage() {
  const search = useAppSelector((state) => state.search.params);
  const { getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState<string | null>(null);
  useEffect(() => {
    getAccessTokenSilently({
      authorizationParams: {
        audience: auth0Config.audience,
      },
    }).then((accessToken) => {
      setToken(accessToken);
    });
  }, [getAccessTokenSilently]);
  return (
    <div className="lookup">
      <h1>Property Search</h1>
      {token && (
        <Candidates
          houseNo={search.houseNo}
          boro={search.boro}
          streetName={search.streetName}
          aptNo={search.aptNo}
          token={token}
        />
      )}
    </div>
  );
}
